// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__359uB","content":"styles_content__OIcxR"};